import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyRoomBlockHotel = loadable(() => import(/* webpackChunkName: "content/guest/hotelbooking/routes/roomblockhotel" */ './RoomBlockHotel'), 'RoomBlockHotel');
